import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SliderService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(private http: HttpClient) { }
  getSlideInfo() {
    const url = environment.apiUrl + `/slider/list`;
    const sliders = this.http.post<any>(url, {
      domain: 1,
      visibility: true
    }, this.httpOptions)
    return sliders;
  }

  getStreamingList() {
    const url = environment.apiUrl + '/liveStreaming/getLiveStreamingUrl';
    return this.http.get<any>(url, this.httpOptions);
  }
}
